import * as REDUX_TYPES from '../types'

const INITIAL_STATE = {
    currentPlayTime: 0
}

const reactorReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case REDUX_TYPES.REACTOR.CURRENT_PLAY_TIME:
            return {
                ...state,
                currentPlayTime: action.currentPlayTime,
            }

        default:
            return state
    }
}
export default reactorReducer